import { render, staticRenderFns } from "./BtChart.vue?vue&type=template&id=65b83dac&scoped=true&"
import script from "./BtChart.vue?vue&type=script&lang=js&"
export * from "./BtChart.vue?vue&type=script&lang=js&"
import style0 from "./BtChart.vue?vue&type=style&index=0&id=65b83dac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b83dac",
  null
  
)

export default component.exports